export const getProvidersForIRT = (currency: string) => {
  if (currency === 'IRT') return ['tvbet'];
  return ['pragmatic', 'evolution'];
};

export const winfinitySort = [
  '6655f385ce1456a05c65ce03', // Cabaret Roulette
  '6655f2c9f0098d3ff363b0a8', // 500xAuto Roulette
  '6655f025f800096c401b7076', // Venice BJ 4
  '6655f0f1792616a56ce30964', // Bar BJ 5
  '689c69182109f3ba4c28a7b6', // Monaco BJ 1
  '6655f061f800096c401b7077', // Auto Roulette
  '6655f2f9f0098d3ff363b0a9', // VIP Auto Roulette
  '6655f090986a217645e02c5a', // Venice Roulette
  '6798a53e3e7e7d5b3536ac14', // Bar Blackjack 4
  '689c692a2109f3ba4c28a7b7', // Monaco BJ 2
];

const casinoHoldemTVBet = ['poker'];
const popularTVBet = ['22', '25', '3', '19', '9', '2'];

const popularXPG = ['xpg2', 'xpg3', 'xpg4', 'xpg1'];
const popularPragmatic = ['234', '227', '225', '204', '545', '240', '229', '240'];
const popularEzugi = ['4151', '270', '272', '273', '274', '275'];

const vipEzugi = ['vip diamond blackjack', 'vip roulette', 'vip surrender blackjack'];
const espanolEzugi = [
  'spanish unlimited blackjack',
  'spanish roulette',
  'ruleta del sol',
  'ez dealer roulette latina',
  'rumba blackjack 2',
  'rumba blackjack 3',
  'rumba blackjack 4',
];
const espanolPragmatic = ['3321', '3322', '3323', '3324', '3325'];
const blackjackEzugi = [
  'spanish unlimited blackjack',
  'blackjack a',
  'blackjack b',
  'blackjack c',
  'blackjack d',
  'blackjack e',
  'blackjack da sorte',
  'gold blackjack 5',
  'gold blackjack 4',
  'platinum blackjack 1',
  'blackjack 1',
  'gold blackjack 3',
  'gold blackjack 1',
  'gold blackjack 6',
  'vip surrender blackjack',
  'vip diamond blackjack',
  'turkish blackjack 1',
  'turkish blackjack 2',
  'russian blackjack 1',
  'russian blackjack 2',
];
const baccaratEzugi = [
  'baccarat a',
  'over under baccarat',
  'baccarat b',
  'baccarat c',
  'baccarat d',
  'baccarat e',
  'casino marina baccarat a',
  'casino marina baccarat b',
  'casino marina baccarat c',
  'casino marina baccarat d',
  'knockout baccarat',
  'super 6 baccarat',
  'no commission baccarat a',
  'no commission baccarat b',
  'no commission baccarat c',
  'no commission baccarat d',
  'no commission baccarat e ',
  'no commission over under baccarat',
];
const rouletteEzugi = [
  'spanish unlimited blackjack',
  'spanish roulette',
  'ruleta del sol',
  'ez dealer roulette latina',
  'ruleta a',
  'roleta da sorte',
  'italian roulette',
  'speed roulette',
  'diamond roulette',
  'namaste roulette',
  'turkish roulette',
  'russian roulette',
  'auto roulette',
  'football auto roulette',
  'speed auto roulette',
  'cricket auto roulette',
  'prestige auto roulette',
  'portomaso roulette 2',
  'oracle roulette 2',
  'oracle 360 roulette',
  'casino marina roulette 1',
  'casino marina roulette 2',
  'vip roulette',
  'oracle real roulette',
  'oracle 360 roulette',
];

const casinoHoldemEzugi = ['Casino Hold'];
const otherGamesEzugi = [
  'cricket war',
  "casino hold'em",
  'teen patti 3 card',
  'bet on teen patti',
  'one day teen patti',
  'russian poker',
  'andar bahar',
  'casino marina andar bahar',
  'ultimate andar bahar',
  'lucky 7',
  '32 cards',
];
const sicBoGamesEzugi = ['sic bo', 'ultimate sic bo'];
const dragonTigerGamesEzugi = ['dragon tiger', 'dragon tiger da sorte'];

const rouletteTVBet = ['roulette', 'wheel'];
const otherGamesTVBet = ['fast keno', 'keno', '1bet', '5bet', '7bet', 'lucky6', 'war of elements'];
const kenoGamesTVBet = ['23', '9'];
const lotteriesGamesTVBet = ['10', '6', '7', '12'];

const kenoGamesPopokGaming = ['609'];

const filteredGames = {
  popular: {
    byName: [
      'roulette 14 - spanish',
      'auto-roulette 1',
      'speed auto-roulette 1',
      'roulette 10 - ruby', // 'roulette 10 - chrome',
      'roulette 1 - azure',
      'mega roulette',
      'speed baccarat 11',
      'speed baccarat 12',
      'speed roulette 1',
      'powerup roulette',
    ],
    byId: [...popularTVBet, ...popularXPG, ...popularEzugi, ...popularPragmatic],
  },
  espanol: {
    byName: [...espanolEzugi],
    byId: ['234', '225', '226', '120602', ...espanolPragmatic],
  },
  vip: {
    byName: [...vipEzugi],
  },
  blackjack: {
    byName: [...blackjackEzugi],
  },
  baccarat: {
    byName: [...baccaratEzugi],
  },
  roulette: {
    byName: [...rouletteTVBet, ...rouletteEzugi],
  },
  casinoHoldem: {
    byName: [...casinoHoldemTVBet, ...casinoHoldemEzugi],
  },
  other: {
    byName: [...otherGamesTVBet, ...otherGamesEzugi],
  },
  sicBo: {
    byName: [...sicBoGamesEzugi],
  },
  dragonTiger: {
    byName: [...dragonTigerGamesEzugi],
  },
  keno: {
    byId: [...kenoGamesTVBet, ...kenoGamesPopokGaming],
  },
  lotteries: {
    byId: [...lotteriesGamesTVBet],
  },
};

export const hideBlackJack = ['721', '722', '723', '724', '725'];

export const allowlistedBlackJackPragmatic = [
  '3141',
  '3142',
  '3143',
  '3144',
  '3145',
  '3321',
  '3322',
  '3323',
  '3324',
  '3325',
  '3231',
  '3232',
  '3233',
  '3234',
  '3235',
  '3238',
  '3239',
  '3240',
  '3241',
  '3242',
];

export const gamesSortJacktop: string[] = [
  '120602',
  '100202',
  '119102',
  '154912',
  '234',
  '118102',
  '140511',
  '119202',
  '100101',
  '119802',
  '103503',
  '110304',
  '120705',
  '134905',
  '130805',
  '131605',
  '131705',
];

export const gamesSortTVBet: string[] = [
  '25', // El Casino Roulette x500
  '22', // Roulette
  '19', // BlackJack
  '3', // Poker
  '219', // Aerobet
  '199', // Spin2Wheels
  '2', // Wheel
  '9', // Keno
  '12', // Lucky6
  '7', // 7Bet
  '6', // 5Bet
  '23', // FAST KENO
  '10', // 1Bet
  '5', // War of Elements
];

export const gamesSortPragmatic: string[] = ['234a11', '225a78', '421a9', '210a122', '234', '3321'];

export const gamesSortArrayById: string[] = [
  ...gamesSortJacktop,
  ...gamesSortPragmatic,
  ...gamesSortTVBet,
  ...filteredGames.popular.byId,
];

export const gamesSortEzugi: string[] = [
  '5001',
  '4151',
  '411000',
  '431000',
  '481009',
  '270',
  '611007',
  '274',
  '275',
  '260',
];

export const gamesSortAmusnet: string[] = ['20333', '20373', '20331', '20330', '20332'];

export const providersSortArray: string[] = [
  'pragmatic',
  'jacktop',
  'tvbet',
  'amusnet',
  'ezugi',
  'winfinity',
  'xpg',
  'popokgaming',
  'vivogaming',
].map(provider => provider.toLowerCase());

export const getCategories = (name: string, id: string, provider?: string): string[] => {
  const categories = [];

  if (provider === 'ezugi') {
    if (filteredGames.espanol.byName.indexOf(name.toLowerCase()) !== -1) categories.push('espanol');
    if (filteredGames.vip.byName.indexOf(name.toLowerCase()) !== -1) categories.push('VIP');
    if (filteredGames.blackjack.byName.indexOf(name.toLowerCase()) !== -1) categories.push('blackjack');
    if (filteredGames.baccarat.byName.indexOf(name.toLowerCase()) !== -1) categories.push('baccarat');
    if (filteredGames.roulette.byName.indexOf(name.toLowerCase()) !== -1) categories.push('roulette');
    if (filteredGames.casinoHoldem.byName.indexOf(name.toLowerCase()) !== -1) categories.push('casinoHoldem');
    if (filteredGames.other.byName.indexOf(name.toLowerCase()) !== -1) categories.push('otherGames');
    if (filteredGames.sicBo.byName.indexOf(name.toLowerCase()) !== -1) categories.push('sikBo');
    if (filteredGames.dragonTiger.byName.indexOf(name.toLowerCase()) !== -1) categories.push('dragonTiger');
    if (popularEzugi.indexOf(id) !== -1) categories.push('popular');

    return categories;
  }

  if (name.toLowerCase().indexOf('blackjack') !== -1) categories.push('blackjack');
  if (name.toLowerCase().indexOf('baccarat') !== -1) categories.push('baccarat');
  if (name.toLowerCase().indexOf('roulette') !== -1) categories.push('roulette');
  if (name.toLowerCase().indexOf('casino') !== -1) categories.push('casinoHoldem');
  if (name.toLowerCase().indexOf('poker') !== -1) categories.push('poker');
  if (name.toLowerCase().indexOf('live') !== -1) categories.push('liveCasino');
  if (name.toLowerCase().indexOf('table') !== -1) categories.push('tableGames');
  if (name.toLowerCase().indexOf('sic bo') !== -1) categories.push('sikBo');
  if (name.toLowerCase().indexOf('dragon tiger') !== -1) categories.push('dragonTiger');
  if (name.toLowerCase().indexOf('dice') !== -1) categories.push('dice');
  if (name.toLowerCase().indexOf('card') !== -1) categories.push('card');
  if (name.toLowerCase().indexOf('espanol') !== -1) categories.push('espanol');
  if (name.toLowerCase().indexOf('vip') !== -1) categories.push('VIP');

  if (filteredGames.popular.byName.indexOf(name.toLowerCase()) !== -1) categories.push('popular');
  if (filteredGames.popular.byId.indexOf(id) !== -1) categories.push('popular');
  if (filteredGames.roulette.byName.indexOf(name.toLowerCase()) !== -1) categories.push('roulette');
  if (filteredGames.other.byName.indexOf(name.toLowerCase()) !== -1) categories.push('otherGames');
  if (filteredGames.casinoHoldem.byName.indexOf(name.toLowerCase()) !== -1) categories.push('casinoHoldem');
  if (filteredGames.keno.byId.indexOf(id) !== -1) categories.push('keno');
  if (filteredGames.lotteries.byId.indexOf(id) !== -1) categories.push('lotteries');
  if (filteredGames.espanol.byId.indexOf(id) !== -1) categories.push('espanol');

  if (categories.length === 0) categories.push('otherGames');

  return categories;
};
